export default "__VITE_ASSET__BewNJ0l9__"